import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-grid-system';
import { prettyCalendarUrl, prettyStandingsUrl } from '../../common/rcs_gaz_mc_core_FE';
import ConfigManager from '../../common/configManager/configManager';
import MatchRowBoxed from '../../components/MatchRowBoxed';
import Label from '../../components/shared/Label';
import ChampionsButton from '../../components/shared/CorriereLink';
import * as types from '../../constants';
import { DayStripWidgetWrapper, MatchWrapper, MainContainerCorriere, ArrowContainer } from './styles';
import IconFont from '../../components/shared/IconFont';

class CalendarCorriereWidget extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      //scollingToLeft: 0,
    };
  }


  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    this.eventTimer = setInterval(this.getCalendar, interval);
    this.getCalendar();
    this.resizeCallback();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.eventTimer) {
      clearInterval(this.eventTimer);
    }
  }

  getCalendar = () => {
    const {
      competitionId, sportId, day, actions,
    } = this.props;

    if (day) {
      actions.getCorriereDayCalendar(sportId, competitionId, day);
    } else {
      actions.getCorriereCalendar(sportId, competitionId);
    }
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 767,
    });
  };

  scrollRightSmooth = (container) => {
    const element = document.querySelector(container);
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += 7;
      scrollAmount += 7;
      if (scrollAmount >= 154) {
        window.clearInterval(slideTimer);
      }
    }, 10);
  };

  scrollLeftSmooth = (container) => {
    const element = document.querySelector(container);
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft -= 7;
      scrollAmount += 7;
      if (scrollAmount >= 154) {
        window.clearInterval(slideTimer);
      }
    }, 10);
  };

  render() {
    const {
      dictionary,
      calendarPre,
      calendarLive,
      calendarAfterLive,
      calendarFull,
      competitionId,
      sportId,
      day,
      calendarDelay,
      calendarPost,
      calendarAbandoned,
      calendarSuspended,
      isCalendarLoaded = false,
    } = this.props;
    const finalDay = (calendarPre && calendarPre.get('currentDay')) ? calendarPre.get('currentDay') : day;
    const { isMobile } = this.state;
    return (
      <div style={{
          paddingTop: '10px',
          backgroundColor: '#fff',
          maxWidth: '1024px',
          margin: 'auto',
        }}
      >
        <MainContainerCorriere>
          <div style={{ width: '100%' }}>
            <DayStripWidgetWrapper
              isMobile={isMobile}
            >
              {calendarPre &&
              <Row style={{
                position: 'static',
                marginTop: '5px',
                width: isMobile ? '100%' : '952px',
                marginLeft: '0px',
                marginRight: '0px',
              }}
              >
                <Col lg={7} md={7} sm={7} style={{ padding: '0px', overflow: 'initial' }}>
                  <Label
                    label="TEMPO REALE "
                    margin={isMobile ? '0px 0px 0px 10px' : '0 0 16px'}
                    font="BreraCondensedBlack"
                    size={0.9}
                    isCapitalize
                    isTitleNarrowMedium
                    className="realTimeTitle"
                  />
                  <a
                    href={`${prettyCalendarUrl(sportId, competitionId, process.env.REACT_APP_SITE)}${types.TRACK_STRING_CONST}`}
                    className="resetLink"
                  >
                    <Label
                      label={`${dictionary.competitionTable.competitionName[competitionId]} - ${finalDay}${dictionary.competitionTable.dayA}`}
                      color="lightBlue2"
                      margin="0 0 16px"
                      isCapitalize
                      size={0.9}
                    />
                  </a>
                </Col>
                <Col lg={5} md={5} sm={5} style={{ padding: '0px' }} className="flex justifyContentEnd alignItemsCenter">
                  {!isMobile &&
                    <React.Fragment>
                      <ChampionsButton
                        color="linkColor"
                        background="transparent"
                        label="Classifica"
                        borderColor="gray"
                        linkTo={`${prettyStandingsUrl(sportId, competitionId, process.env.REACT_APP_SITE)}${types.TRACK_STRING_CONST}`}
                        width="35%"
                      />
                      <ChampionsButton
                        color="linkColor"
                        background="transparent"
                        label="Calendario e risultati"
                        borderColor="gray"
                        linkTo={`${prettyCalendarUrl(sportId, competitionId, process.env.REACT_APP_SITE)}${types.TRACK_STRING_CONST}`}
                        width="60%"
                      />
                    </React.Fragment>
                  }
                </Col>
              </Row>
              }
              <Col lg={12} md={12} sm={12} style={{ padding: '0px', 'min-height': isMobile ? '186px' : '116px' }} className="flex justifyContentBetween">
                {!isMobile &&
                <ArrowContainer>
                  <IconFont
                    marginBottom={0.1}
                    marginTop={1.3}
                    className="icon-matchcenter-arrow"
                    font={23}
                    color="lightBlue2"
                    withCursor
                    onClick={() => this.scrollLeftSmooth('.matchWrapperRow')}
                    rotate="true"
                  />
                </ArrowContainer>
                }
                <MatchWrapper className="matchWrapperRow">
                  {isCalendarLoaded && calendarLive && calendarLive.get('games') && calendarLive.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarAfterLive && calendarAfterLive.get('games') && calendarAfterLive.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarSuspended && calendarSuspended.get('games') && calendarSuspended.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarPre && calendarPre.get('games') && calendarPre.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  { isCalendarLoaded && calendarDelay && calendarDelay.get('games') && calendarDelay.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarAbandoned && calendarAbandoned.get('games') && calendarAbandoned.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarFull && calendarFull.get('games') && calendarFull.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                  {isCalendarLoaded && calendarPost && calendarPost.get('games') && calendarPost.get('games').map(d => (
                    d && d.get('matches') && d.get('matches').map((match, index) => (
                      <MatchRowBoxed
                        matchRow={match}
                        key={index}
                        dictionary={dictionary.competitionTable}
                        isMobile={isMobile}
                        sportId={sportId}
                        competitionId={competitionId}
                        trackString={types.TRACK_STRING_CONST}
                      />
                    ))
                  ))
                  }
                </MatchWrapper>
              </Col>
              {isMobile &&
              <Row
                style={{
                  position: 'absolute',
                  bottom: '15px',
                  width: '100%',
                  'min-height': '5px',
                }}
                className="flex justifyContentCenter alignItemsCenter"
              >
                <Col lg={6} md={6} sm={6} style={{ padding: '0px' }} className="flex justifyContentCenter alignItemsCenter">
                  <ChampionsButton
                    color="linkColor"
                    background="transparent"
                    label="Classifica"
                    borderColor="gray"
                    linkTo={`${prettyStandingsUrl(sportId, competitionId, process.env.REACT_APP_SITE)}${types.TRACK_STRING_CONST}`}
                    isBottomLink
                  />
                </Col>
                <Col lg={6} md={6} sm={6} style={{ padding: '0px' }} className="flex justifyContentCenter alignItemsCenter">
                  <ChampionsButton
                    color="linkColor"
                    background="transparent"
                    label="Calendario"
                    borderColor="gray"
                    linkTo={`${prettyCalendarUrl(sportId, competitionId, process.env.REACT_APP_SITE)}${types.TRACK_STRING_CONST}`}
                    isBottomLink
                  />
                </Col>
              </Row>
              }
            </DayStripWidgetWrapper>
          </div>
          {!isMobile &&
            <ArrowContainer>
              <IconFont
                className="icon-matchcenter-arrow"
                font={23}
                color="lightBlue2"
                withCursor
                onClick={() => this.scrollRightSmooth('.matchWrapperRow')}
                marginTop={2.4}
                paddingRight="3px"
              />
            </ArrowContainer>
          }
        </MainContainerCorriere>
      </div>
    );
  }
}

CalendarCorriereWidget.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  day: PropTypes.any,
  calendarPre: PropTypes.any,
  calendarLive: PropTypes.any,
  calendarAfterLive: PropTypes.any,
  calendarFull: PropTypes.any,
  calendarDelay: PropTypes.any,
  calendarPost: PropTypes.any,
  calendarAbandoned: PropTypes.any,
  calendarSuspended: PropTypes.any,
  isCalendarLoaded: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    calendarPre: state.calendarReducer.get('calendarPre'),
    calendarLive: state.calendarReducer.get('calendarLive'),
    calendarAfterLive: state.calendarReducer.get('calendarAfterLive'),
    calendarFull: state.calendarReducer.get('calendarFull'),
    calendarDelay: state.calendarReducer.get('calendarDelay'),
    calendarPost: state.calendarReducer.get('calendarPost'),
    calendarAbandoned: state.calendarReducer.get('calendarAbandoned'),
    calendarSuspended: state.calendarReducer.get('calendarSuspended'),
    isCalendarLoaded: state.calendarReducer.get('isCalendarLoaded'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getCorriereCalendar: (sportId, competitionId) =>
        dispatch({
          type: types.GET_CALENDAR_CORRIERE_REQUEST,
          sportId,
          competitionId,
        }),
      getCorriereDayCalendar: (sportId, competitionId, day) =>
        dispatch({
          type: types.GET_DAY_CALENDAR_CORRIERE_REQUEST,
          sportId,
          competitionId,
          day,
        }),
    },
  }),
)(CalendarCorriereWidget);



// WEBPACK FOOTER //
// ./src/containers/CalendarCorriereWidget/index.js